import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteDobovoOrganization,
    fetchDobovoOrganizations,
    postDobovoOrganization,
    updateDobovoOrganization
} from '../../../../../api/dobovoApi/dobovoOrganizations'
import {
    selectOrganizations,
    selectOrganizationsFetching
} from '../../../../../selectors/dobovoSelectors/dobovoOrganizations'
import OrganizationsTable from './OrganizationTable'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class OrganizationTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        organizations: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchDobovoOrganizations: PropTypes.func.isRequired,
        postDobovoOrganization: PropTypes.func.isRequired,
        deleteDobovoOrganization: PropTypes.func.isRequired,
        updateDobovoOrganization: PropTypes.func.isRequired
    }

    state = {
        id: '',
        name: '',
        token: ''
    }

    componentDidMount() {
        const params = { size: 300 }
        this.props.fetchDobovoOrganizations(params)
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleClick = () => {
        const { id, name, token } = this.state
        this.props.postDobovoOrganization({
            id,
            name,
            token
        })
        this.setState({
            id: '',
            name: '',
            token: ''
        })
    }

    handleDelete = id => {
        this.props.deleteDobovoOrganization(id)
    }

    handleUpdate = organization => {
        this.props.updateDobovoOrganization(organization.id, { ...organization })
    }

    render() {
        const { classes, fetching, organizations } = this.props
        const { id, name, token } = this.state

        const valid = id && name && token

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-id">ID организации Dobovo.com</InputLabel>
                        <Input id="org-remote-id" name="id" value={id} onChange={this.handleChange} />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-remote-name">Имя организации Dobovo.com</InputLabel>
                        <Input id="org-remote-name" name="name" value={name} onChange={this.handleChange} />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="org-property-password">Token</InputLabel>
                        <Input id="org-property-password" name="token" value={token} onChange={this.handleChange} />
                    </FormControl>

                    <Button
                        disabled={!valid}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleClick}
                    >
                        Сохранить
                    </Button>
                </Paper>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <OrganizationsTable
                        organizations={organizations}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        organizations: selectOrganizations(state),
        fetching: selectOrganizationsFetching(state)
    }),
    {
        fetchDobovoOrganizations,
        postDobovoOrganization,
        updateDobovoOrganization,
        deleteDobovoOrganization
    }
)(withStyles(styles)(OrganizationTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/OrganizationTab/OrganizationTab.js